import { Component, Getter, mixins } from 'nuxt-property-decorator';
import { TSiteConfigState } from '~/store/types';
import { SanityDocumentSchema } from '~/types/sanity-documents';
import { Auth0ThemeType } from '~/types/authTheme';
import SanityDocumentPage from '~/mixins/SanityDocumentPage';
import { Image as SanityImageObject } from '@sanity/types';

@Component
export class SanityAuth extends mixins(SanityDocumentPage) {
  @Getter('siteConfig')
  readonly siteConfigState!: TSiteConfigState;

  schemas = SanityDocumentSchema;

  getSanitizedUrl(url: SanityImageObject): string | null {
    let sanitizedUrl = url ? this.$sanityImage.urlFor(url).url() : null;
    if (sanitizedUrl?.includes('?')) {
      sanitizedUrl = sanitizedUrl.split('?')[0];
    }
    return sanitizedUrl;
  }

  getHexColor(color: { hex: string }) {
    return color?.hex?.replace('#', '');
  }

  get authTheme() {
    const authTheme =
      this.pageState?.data?.auth?.theme ||
      this.siteConfigState?.data?.auth?.theme;
    return authTheme;
  }

  get authBackground() {
    if (
      this.authTheme.backgroundType === Auth0ThemeType.IMAGE &&
      this.authTheme.background
    ) {
      return this.getSanitizedUrl(this.authTheme.background);
    } else if (
      this.authTheme.backgroundType === Auth0ThemeType.VIDEO &&
      this.authTheme.videoBackground
    ) {
      return this.authTheme.videoBackground;
    } else {
      return undefined;
    }
  }

  get auth0ThemeParams() {
    if (this.authTheme === undefined) {
      return {};
    }
    const extParams: Record<string, string | undefined> = {
      'ext-title': this.authTheme.title || undefined,
      'ext-background-type':
        this.authTheme.backgroundType?.toString() || undefined,
      'ext-background': this.authBackground,
      'ext-title-color':
        this.getHexColor(this.authTheme?.titleColor) || undefined,
      'ext-link-color':
        this.getHexColor(this.authTheme?.linkColor) || undefined,
      'ext-position': this.authTheme.loginPosition || undefined,
      'ext-overlay': this.authTheme.overlay || undefined,
    };
    return extParams;
  }
}
